import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import { Link } from 'react-router-dom'
import { ApiService } from '../../../Components/Services/apiServices';


const Carousel = () => {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchBanners = async () => {
            try {
                const bannerData = await ApiService.Commanfetchrequest('banners');
                setBanners(bannerData);
                // console.log('Fetched Banners:', bannerData);
            } catch (error) {
                console.error('Error fetching banners:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchBanners();
    }, []);

    return (
        <>

            {loading ? (
                <>
                    <div className="container-fluid p-0 mb-5">
                        <div id="header-carousel" className="carousel slide" data-bs-ride="carousel">
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <Skeleton width={"100%"} height={500} />
                                    <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                                        <div className="p-3" style={{ maxWidth: 700 }}>
                                            <h6 className="section-title text-white text-uppercase mb-3 animated slideInDown"><Skeleton width={"100%"} height={40} baseColor='#fff'/></h6>
                                            <h1 className="display-3 text-white mb-4 animated slideInDown"><Skeleton width={"100%"} height={140}/></h1>
                                            <Link to="/rooms" style={{ BackgroundColor: "#FEA116", color: "#fff", fontWeight: "600" }} className="btn  py-md-3 px-md-5 me-3 animated slideInLeft"><Skeleton width={120} height={50}/></Link>
                                            <Link onClick={(e) => {
                                                e.preventDefault();
                                                document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
                                            }} style={{ fontWeight: "600" }} className="btn  py-md-3 px-md-5 animated slideInRight mt-md-0 mt-3"><Skeleton width={120} height={50}/></Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="carousel-item">
                                    <Skeleton width={"100%"} height={500} />
                                    <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                                        <div className="p-3" style={{ maxWidth: 700 }}>
                                            <h6 className="section-title text-white text-uppercase mb-3 animated slideInDown"><Skeleton width={"100%"} height={40} color={"white"}/></h6>
                                            <h1 className="display-3 text-white mb-4 animated slideInDown"><Skeleton width={"100%"} height={140}/></h1>
                                            <Link to="/rooms" style={{ BackgroundColor: "#FEA116", color: "#fff", fontWeight: "600" }} className="btn  py-md-3 px-md-5 me-3 animated slideInLeft"><Skeleton width={120} height={50}/></Link>
                                            <Link onClick={(e) => {
                                                e.preventDefault();
                                                document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
                                            }} style={{ fontWeight: "600" }} className="btn py-md-3 px-md-5 animated slideInRight mt-md-0 mt-3"><Skeleton width={120} height={50}/></Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true" />
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true" />
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                </>
            ) : (
                <div className="container-fluid p-0 mb-5">
                    <div id="header-carousel" className="carousel slide" data-bs-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <img className="w-100" src={`https://hoteljpradmin.loopring.in/front/images/banners/${banners[0]?.image}`} alt="Image" />
                                <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                                    <div className="p-3" style={{ maxWidth: 700 }}>
                                        <h6 className="section-title text-white text-uppercase mb-3 animated slideInDown">Luxury Living</h6>
                                        <h1 className="display-3 text-white mb-4 animated slideInDown">{banners[0]?.title}</h1>
                                        <Link to="/rooms" style={{ BackgroundColor: "#FEA116", color: "#fff", fontWeight: "600" }} className="btn btn-warning py-md-3 px-md-5 me-3 animated slideInLeft">Our Rooms</Link>
                                        <Link onClick={(e) => {
                                            e.preventDefault();
                                            document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
                                        }} style={{ fontWeight: "600" }} className="btn btn-light py-md-3 px-md-5 animated slideInRight mt-md-0 mt-3">Book A Room</Link>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item">
                                <img className="w-100" src={`https://hoteljpradmin.loopring.in/front/images/banners/${banners[1]?.image}`} alt="Image" />
                                <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                                    <div className="p-3" style={{ maxWidth: 700 }}>
                                        <h6 className="section-title text-white text-uppercase mb-3 animated slideInDown">Luxury Living</h6>
                                        <h1 className="display-3 text-white mb-4 animated slideInDown">{banners[1]?.title}</h1>
                                        <Link to="/rooms" style={{ BackgroundColor: "#FEA116", color: "#fff", fontWeight: "600" }} className="btn btn-warning py-md-3 px-md-5 me-3 animated slideInLeft">Our Rooms</Link>
                                        <Link onClick={(e) => {
                                            e.preventDefault();
                                            document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
                                        }} style={{ fontWeight: "600" }} className="btn btn-light py-md-3 px-md-5 animated slideInRight mt-md-0 mt-3">Book A Room</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true" />
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true" />
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>
            )}

        </>
    )
}

export default Carousel
